export function getComponentValue(addressComponents, type, length = 'long') {
    const component = addressComponents.find((a) => a.types.indexOf(type) !== -1);
    if (!component) {
        return '';
    }
    if (length === 'long') {
        return component.long_name;
    }
    return component.short_name;
}
